import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MRDN_GRAY } from 'constants/theme';
import styled from '@emotion/styled';
import { showLinks } from 'constants/common';
import FooterLinks from './FooterLinks';

const StyledFooter = styled('footer')`
  background: ${MRDN_GRAY};
  margin-left: auto;
  margin-right: auto;
  padding: 40px 32px;
  width: 100%;

  @media only screen and (min-width: 768px) {
    padding: 64px;
  }

  @media only screen and (max-width: 320px) {
    padding-right: 16px;
    padding-left: 16px;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    padding-bottom: 103px;
  }
`;

const StyledSmall = styled('small')`
  p {
    font-family: ${({ theme }) => theme.fonts.soehneBuch};
    font-size: 12px;
    color: ${({ theme }) => theme.text.dark};
    letter-spacing: 0;
    margin: 0;
    padding: 8px 0 0;
  }
`;

function SiteFooter({ location, isPetInsurancePage = false }) {
  const [showLink, setShowLink] = useState(true);

  useEffect(() => {
    setShowLink(showLinks());
  }, [location?.pathname]);

  return (
    <StyledFooter role='contentinfo'>
      {showLink && <FooterLinks location={location} />}
      <StyledSmall>
        <p>© {new Date().getFullYear()} Homebody Insurance Agency, LLC™</p>
        {isPetInsurancePage && (
          <p>
            Pet health insurance is administered by Embrace Pet Insurance Agency, Limited Liability Company and
            underwritten by one of the licensed insurers of American Modern Insurance Group, Incorporated, including
            American Modern Home Insurance Company doing business in California as American Modern Insurance Company
            (License Number 2222-8), and American Southern Home Insurance Company. Coverage is subject to policy terms,
            conditions, limitations, exclusions, underwriting, review and approval, and may not be available for all
            risks or in all states. Rates and discounts vary, are determined by many factors and are subject to change.
            Wellness rewards are offered as a supplementary benefit to the pet health insurance policy and are not an
            insurance product. Wellness rewards are offered and administered by Embrace Pet Insurance Agency in the
            United States. © 2022 American Modern Insurance Group, Incorporated.
          </p>
        )}
      </StyledSmall>
    </StyledFooter>
  );
}

SiteFooter.propTypes = {
  isPetInsurancePage: PropTypes.bool,
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.any]),
};

SiteFooter.defaultProps = {
  isPetInsurancePage: false,
  location: null,
};

export default SiteFooter;
